import * as React from 'react'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'
import { RouteComponentProps, withRouter } from 'react-router'

import { Table, Button } from 'reactstrap'

import { ClaimInvoice } from '../../lib/interfaces/ClaimInvoice.interface'

import Moment from 'react-moment'
import * as CurrencyFormat from 'react-currency-format'

import Breadcrumbs from '../Breadcrumbs.component'

import * as invoicesActions from '../../store/invoices/actions'

const get = require('lodash/get')
const map = require('lodash/map')
const compact = require('lodash/compact')

export interface InvoicesListPageProps extends RouteComponentProps {
  isLoading: boolean
  invoices?: [ClaimInvoice]
  fetchInvoicesList: () => void
}

class InvoicesListPage extends React.PureComponent<InvoicesListPageProps> {
  componentDidMount() {
    const { fetchInvoicesList } = this.props
    fetchInvoicesList()
  }

  renderLoadingCell() {
    return (
      <tr>
        <td colSpan={8} className="text-center">
          Loading...
        </td>
      </tr>
    )
  }

  renderPaidBy(invoice) {
    return compact([get(invoice, 'paidBy.firstName'), get(invoice, 'paidBy.lastName')]).join(' ')
  }

  render() {
    const { invoices, isLoading } = this.props

    return (
      <div>
        <Breadcrumbs breadcrumbs={[
          { name: 'Dashboard', link: '/dashboard' },
          { name: 'Invoices', active: true }
        ]} />
        <div className="page">
          <div className="d-flex align-items-center mb-2">
            <h5 className="title mb-0">Invoices</h5>
            <Link to="/invoices/add">
              <Button className="ggbutton btn-sm btn-dark ml-3">Add</Button>
            </Link>
          </div>

          <Table hover className="table table-striped">
            <thead>
              <tr>
                <th>Check Number</th>
                <th>Claims</th>
                <th>Cost</th>
                <th>Paid by</th>
                <th>Date created</th>
                <th>Date paid</th>
              </tr>
            </thead>
            <tbody>
              {isLoading && this.renderLoadingCell()}
              {!isLoading && map(invoices, invoice => (
                <tr key={invoice.id} style={{ cursor: 'pointer' }} onClick={() => this.props.history.push(`/invoices/${invoice.id}`)}>
                  <td>{get(invoice, 'checkNumber')}</td>
                  <td>{get(invoice, 'claimsCount', 0)}</td>
                  <td>
                    <CurrencyFormat
                      prefix="$"
                      decimalScale={2}
                      displayType="text"
                      thousandSeparator={true}
                      fixedDecimalScale={true}
                      value={get(invoice, 'cost')}
                    />
                  </td>
                  <td>{this.renderPaidBy(invoice)}</td>
                  <td>
                    <Moment date={get(invoice, 'dateCreated')} format="MM.DD.YYYY" />
                  </td>
                  <td>
                    {invoice.datePaid && <Moment date={invoice.datePaid} format="MM.DD.YYYY" />}
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        </div>
      </div>
    )
  }
}

const mapStateToProps = ({ invoices }) => ({
  invoices: invoices.invoices,
  isLoading: invoices.isFetching
})

const mapDispatchToProps = (dispatch) => ({
  fetchInvoicesList: () => dispatch(invoicesActions.fetchInvoicesList())
})

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(InvoicesListPage))



// WEBPACK FOOTER //
// ./src/routes/invoices/InvoicesList.page.tsx